let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cfCwZ")).then(() => parcelRequire('1dsYb'));